import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const IncidentRoute: Route = {
  path: 'incident',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/incident.component').then((m) => m.IncidentComponent),
    },
    {
      path: ':incidentId',
      loadComponent: () => import('./pages/incident-details.component').then((m) => m.IncidentDetailsComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
